var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-box"},[_c('div',{staticClass:"element-wrapper"},[_c('div',{staticClass:"element-box"},[_c('h5')])])])}]

export { render, staticRenderFns }